import {
    GET_QUANTITATIVE_ACTIVITY,
    GET_QUANTITATIVE_MOVEMENT,
} from './quantitativeMovement.actionsTypes';

export default function quantitativeMovements(state = {}, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case GET_QUANTITATIVE_MOVEMENT:
            return {
                ...newState,
                list: action.payload || [],
            };
        case GET_QUANTITATIVE_ACTIVITY:
            return {
                ...newState,
                activityList: action.payload || []
            }
        default:
            return newState;
        }
}